export * from './DeleteAndConfirmWidgetProps'
